<!--
     <GlobalSearch />
     Reads from vuex:
     - globalSearchText
-->

<template>
  <div v-if="apply_filters" class="generic-explorer-cont">
      <GenericExplorer
        v-if="apply_filters"
        :filters="apply_filters"
        :views="[{name: 'ExplorerTable',...props['ExplorerTable']}]"
        headless
        
      />
  </div>
</template>

<style lang="scss">
 .generic-explorer-cont {
   display: flex;
   flex-direction: column;
   width: 100%;
 }
</style>

<script>
 import { mapActions, mapMutations, mapState, mapGetters } from 'vuex'
 import GenericExplorer from '@/components/explorer/GenericExplorer'
 import QUnitCollection from '@/qunit/QUnitCollection'
 import { QFilters, get_qfilter } from '@/qunit/filters';

 export default {
   name: 'GlobalSearch',

   components: {
     GenericExplorer,
   },

   data: () => ({
     filters: new QFilters(),
     apply_filters: null,
     qunits: null,
     loading: false,
     business_process: null,
     view_name: 'ExplorerTable',
     props: {
        'ExplorerTable': {
          'function': QUnitCollection.globalSearch,
          'selectable': true,
          'actions': true,
          'navigate': true,
          'server_pagination': true
        },
     },
   }),

   mounted() {
     this.update_search();
   },

   computed: {
     ...mapGetters([
       'sitePath',
       'centro_id',
     ]),
     ...mapState([
       'globalSearchText',
     ]),
   },

   methods: {

     update_search() {
       console.warn(this.globalSearchText);
       console.warn(this);
       this.filters.set_filter(get_qfilter('centro',this.centro_id));
       this.filters.set_filter(get_qfilter('search',this.globalSearchText));
       if (this.globalSearchText)
         this.merge_filters();
     },

     merge_filters() {
       this.apply_filters = new QFilters(this.filters);
     },
   },

   watch: {

     globalSearchText() {
       this.$nextTick(this.update_search);
     }
   }
 }

</script>
